import { ApplicationState } from './reducer'

export const initialState: ApplicationState = { openModal: null }
